import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './redux/reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { checkPendingActions } from './utils/actionsDependencies';

const middlewares = [];

const actionsDependencies = (store) => (next) => (action) => {
  next(action);
  checkPendingActions(store.getState());
};

middlewares.push(actionsDependencies);
middlewares.push(thunk);

const store = composeWithDevTools(applyMiddleware(...middlewares))(createStore)(
  reducers
);

export default store;
